import { Fragment } from 'react';
// @mui
import { Box } from '@mui/material';
import NorthEastRounded from '@mui/icons-material/NorthEastRounded';
//
import { COMPANY } from '../../../config/company';
import { STAGE } from '../../../theme/stage';
import type { CompanyField, Rich as RichParts } from '../copy';
import Accent from './Accent';
import Placeholder from './Placeholder';

// ----------------------------------------------------------------------

type Props = {
  parts: RichParts;
};

const LINK = {
  color: STAGE.ink,
  textDecoration: 'underline',
  textDecorationThickness: '1px',
  textDecorationColor: STAGE.lineStrong,
  textUnderlineOffset: '.2em',
  '@media (hover: hover)': { '&:hover': { textDecorationColor: 'currentColor' } },
} as const;

function CompanyValue({ field }: { field: CompanyField }) {
  const value = COMPANY[field];

  if (value === null) {
    return <Placeholder field={field} />;
  }

  if (field === 'email') {
    return (
      <Box component="a" href={`mailto:${value}`} sx={LINK}>
        {value}
      </Box>
    );
  }

  return <>{value}</>;
}

export default function Rich({ parts }: Props) {
  return (
    <>
      {parts.map((part, index) => {
        if (typeof part === 'string') {
          return <Fragment key={index}>{part}</Fragment>;
        }
        if ('b' in part) {
          return (
            <Box key={index} component="strong" sx={{ color: STAGE.ink, fontWeight: 500 }}>
              {part.b}
            </Box>
          );
        }
        if ('i' in part) {
          return <Accent key={index}>{part.i}</Accent>;
        }
        if ('field' in part) {
          return <CompanyValue key={index} field={part.field} />;
        }
        return (
          <Box key={index} component="a" href={part.href} sx={LINK}>
            {part.label}
            <NorthEastRounded
              aria-hidden
              sx={{ fontSize: '.8em', ml: '.12em', verticalAlign: '-.06em' }}
            />
          </Box>
        );
      })}
    </>
  );
}
